export interface AriaOptions {
  label?: string;
  loadingLabel?: string;
  describedby?: string;
  details?: string;
  labelledby?: string;
  role?: 'button' | 'link' | 'searchbox' | 'tab';
  disabled?: boolean;
  controls?: string;
  selected?: boolean;
  activedescendant?: string;
  expanded?: boolean;
  hidden?: boolean;
  posinset?: number;
  setsize?: number;
}

export interface Attachment {
  error?: AttachmentError;
  file: File;
  fileId?: string;
  status?: AttachmentStatus;
}

export enum AttachmentError {
  DUPLICATE = 'duplicate',
  EXTENSION = 'extension',
  MALWARE = 'malware',
  MAX_ATTACHMENTS = 'maxAttachments',
  MAX_SIZE = 'maxSize',
  PATTERN = 'pattern',
  REQUIRED = 'required',
  UPLOADING = 'uploading',
  UNKNOWN = 'unknown',
}

export enum AttachmentStatus {
  ERROR = 'ERROR',
  READY = 'READY',
  UPLOADING = 'UPLOADING',
}

export interface DatepickerTitleAreaOptions {
  titleAreaStyle?: string;
  title?: string;
  titleStyle?: string;
}

export interface FileUploaderI18n {
  attachFile: string;
  attachFiles: string;
  browseFiles: string;
  dragAndDrop: string;
  errors: {
    duplicateSingle: string;
    duplicateMultiple: string;
    invalidFileSizeSingle: string;
    invalidFileSizeMultiple: string;
    invalidFileTypeSingle: string;
    invalidFileTypeMultiple: string;
    maxAttachments: string;
    malwareSingle: string;
    malwareMultiple: string;
    required: string;
    requiredMultiple: string;
    unknown: string;
  };
  filesSupported: string;
  maxAttachments: string;
  maxFileSize: string;
  megaBytes: string;
  or: string;
}
